import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.section `
  padding: var(--space-400);
  border-top: 1px solid var(--border-secondary);
  border-bottom: 1px solid var(--border-secondary);

  ${mediaQueries.tablet} {
    padding: var(--space-500);
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);

    transition: border-color var(--motion-duration-100) var(--motion-ease-in-out);

    &:hover {
      border-color: var(--border-secondary-hover);
    }
  }
`;
export const Header = styled.div `
  display: grid;
  gap: var(--space-500);

  ${mediaQueries.tablet} {
    grid-template-columns: 1fr auto;
    gap: var(--space-600);
    align-items: center;
  }
`;
export const ButtonGroup = styled.div `
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  gap: var(--space-200);

  & > * {
    flex: 1;
  }

  ${mediaQueries.tablet} {
    gap: var(--space-300);
    width: auto;
    flex-direction: row;

    & > * {
      flex: 0;
    }
  }
`;
export const SliderContainer = styled.div `
  margin-top: var(--space-300);

  ${mediaQueries.tablet} {
    margin-top: 0;
  }
`;
export const SliderHeader = styled.div `
  margin-bottom: var(--space-300);
  margin-top: ${({ $marginTop }) => ($marginTop ? 'var(--space-300)' : '0')};

  ${mediaQueries.laptop} {
    margin-bottom: var(--space-400);
    margin-top: ${({ $marginTop }) => ($marginTop ? 'var(--space-400)' : '0')};
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Footer = styled.footer `
  margin-top: var(--space-600);

  text-align: center;

  ${mediaQueries.laptop} {
    margin-top: var(--space-400);
  }
`;
// Skeleton components
export const SkeletonSlider = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--space-400);
  margin-top: var(--space-400);

  ${mediaQueries.tablet} {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--space-500);
  }

  ${mediaQueries.laptop} {
    grid-template-columns: repeat(5, 1fr);
  }
`;
export const SkeletonCard = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
export const SkeletonProductImage = styled.div `
  aspect-ratio: 3/4;
  background: var(--bg-secondary);
  border-radius: var(--radius-brand);
`;
export const SkeletonProductInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`;
